import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=610395b9&scoped=true"
import script from "./signup.vue?vue&type=script&lang=ts"
export * from "./signup.vue?vue&type=script&lang=ts"
import style0 from "./signup.vue?vue&type=style&index=0&id=610395b9&prod&lang=less"
import style1 from "./signup.vue?vue&type=style&index=1&id=610395b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610395b9",
  null
  
)

export default component.exports